import React from 'react';
import { Outlet } from 'react-router-dom';
import AccountPartnerList from 'page/Application/ManagerAccountPartner/AccountPartnerList';
import RegisterAccountPartner from 'page/Application/ManagerAccountPartner/RegisterAccountPartner';
import EditAccountPartner from 'page/Application/ManagerAccountPartner/EditAccountPartner';

const ManagerAccountPartner = () => {
  return <Outlet />;
};

export default ManagerAccountPartner;

export { AccountPartnerList, RegisterAccountPartner, EditAccountPartner };
